import React, { useLayoutEffect, useState, useRef, useCallback} from 'react'
import * as THREE from 'three'
import {Text} from '@react-three/drei'
import useInputStore from '../store/inputStore'
import useDragLineStore from '../store/dragLineStore'
import useHover from '../utils/useHover'
import '../App.css'

function Angle({pt1, pt2, pt3, order}) {
  const dragMode = useDragLineStore(state => state.dragMode)
  const setEditMode = useInputStore(state => state.setEditMode)
  const setText = useInputStore(state => state.setText)
  const setPosition = useInputStore(state => state.setPosition)
  const setIndex = useInputStore(state => state.setIndex)
  const setType = useInputStore(state => state.setType)
  const setData = useInputStore(state => state.setData)
  const [angleDeg, setAngleDeg] = useState() //angle between vectors in degrees (with o superscript)
  const [angleRad, setAngleRad] = useState() // angle between vectors in radians
  const [circleArgs, setCircleArgs] = useState()
  

  // const [position, setPosition] = useState(null)
  const angleRef = useRef();
  const arcRef = useRef();

  const [bindHover, hovered] = useHover();

  const calcParams = useCallback(() => {
     //Calculate angle betweeen 2 vectors
     const vec1 = new THREE.Vector3(pt1[0] - pt2[0], pt1[1] - pt2[1], pt1[2] - pt2[2]);
     const vec2 = new THREE.Vector3(pt3[0] - pt2[0], pt3[1] - pt2[1], pt3[2] - pt2[2]);
     const angRad = vec1.angleTo(vec2);
     const angDeg = (angRad * 180 / Math.PI).toFixed(0) + '⁰';
     setAngleDeg(angDeg);
     setAngleRad(angRad);

     // Calculate mid-point between vec1 and vec2 at a distance 'dist' unit along each of the vector
     const dist = 10;
     const vec3 = vec1.normalize().multiplyScalar(dist);
     const vec4 = vec2.normalize().multiplyScalar(dist);
     const mid_pt = new THREE.Vector3();
     mid_pt.addVectors(vec3, vec4).divideScalar(0.5);
 
     //Calculate position to place the angle text
     const intersecting_point = new THREE.Vector3(pt2[0], pt2[1], pt2[2]);
     const angle_position = new THREE.Vector3();
     angle_position.addVectors(intersecting_point, mid_pt.multiplyScalar(dist / mid_pt.length()));
     angleRef.current.position.x = angle_position.x;
     angleRef.current.position.y = angle_position.y;
     angleRef.current.position.z = 0;
  
 
     //Finding where to start drawing the arc
     let angleStart = 0
     const refAngle =  new THREE.Vector3(1,0,0);
     const ang3 = vec3.y < 0 ? 2 * Math.PI - vec3.angleTo(refAngle) : vec3.angleTo(refAngle)
     const ang4 = vec4.y < 0 ? 2 * Math.PI - vec4.angleTo(refAngle) : vec4.angleTo(refAngle)
     angleStart = Math.abs(ang3 - ang4) > Math.PI ? Math.max(ang3, ang4) : Math.min(ang3, ang4);

 
     setCircleArgs([15,8,angleStart,angRad])

     arcRef.current.position.x = pt2[0];
     arcRef.current.position.y = pt2[1];
     arcRef.current.position.z = 0;
  }, [pt1,pt2,pt3])

  useLayoutEffect (() => {
 
    calcParams();
  }, [calcParams])

  const changeEditMode = (e) => {
    e.stopPropagation()
    if (!dragMode){
      setEditMode(true)
      if (e.object._private_text){
        //Set required data for editing of text
        let txt = e.object._private_text
        txt = txt.replace('⁰','')
        setText(txt)
        setData(e.object.userData)
        setPosition(e.point.toArray())
        setIndex(order)
        setType('angle');
      }
      console.log('Event ang', e )

    }

  }
 
  return (
    <>
      <Text
        onDoubleClick={changeEditMode}
        {...bindHover}
        ref={angleRef}
        scale={[0.3,0.3,0.3]}
        color={hovered ? '#027DC3':'black'}
        // color='black'
        anchorX="center"
        anchorY="middle"
        maxWidth={200}
        lineHeight={1}
        fontSize = {30}
        font="https://fonts.gstatic.com/s/raleway/v14/1Ptrg8zYS_SKggPNwK4vaqI.woff"
        letterSpacing={0.02}
        textAlign={'left'}
        userData={angleRad}
      >
        {angleDeg}
      </Text>
      <mesh ref={arcRef}>
        <circleBufferGeometry args={circleArgs} />
        <meshBasicMaterial/>
      </mesh>
    </>
  )
}

export default Angle
